import { Navigate, useParams } from "react-router"

import { useCurrentUser } from "@/features/auth"
import { opensReviewInWorkspace, reviewLandingPath } from "@/lib/roles"

import { ReviewPage } from "./review-page"

/** The version slot as the queue writes it: `v` and a version number. */
const VERSION_SEGMENT = /^v\d+$/

/**
 * The workspace route, `/reviews/:id` and `/reviews/:id/:version`.
 *
 * A client reads a review as its report, so any way into the workspace — a
 * bookmark, an emailed link, a typed URL — lands a client on the same review's
 * report instead. Staff get the workspace.
 */
export function ReviewRoute(): JSX.Element {
  const { id, version } = useParams<{ id: string; version?: string }>()
  const role = useCurrentUser()?.role
  // The queue links a version as `/reviews/:id/v2`. Anything else in that slot is a typo, and
  // the id in front of it is still the useful part: go to the review itself, which then shows
  // it or says it is not there and points at the queue.
  if (id && version !== undefined && !VERSION_SEGMENT.test(version)) {
    return <Navigate to={`/reviews/${encodeURIComponent(id)}`} replace />
  }
  if (id && !opensReviewInWorkspace(role)) {
    return <Navigate to={reviewLandingPath(role, id)} replace />
  }
  return <ReviewPage />
}
